import "./About.module.css";
import Header from "@/reusable_sections/Header";
import Heritage from "./sections/Heritage";
import Engineering from "./sections/Engineering";
import Credentials from "./sections/Credentials";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Header />
      <Heritage />
      <Engineering />
      <Credentials />
      <Footer />
    </div>;
}